<template>
    <div class="dropdown" :class="{'dropdown--single-select': isSingleSelect}" v-if="config && labels">
        
        <FocusLock
        :returnfocus="false" 
        :disabled="!open">

            <label :id="labelByKey()" v-if="isSingleSelect && anySelected()" class="floating-label">{{label}}</label>
            <div class="dropdown__title" 
                :class="{'dropdown__title--shrink': isSingleSelect && anySelected()}" 
                tabindex="0" 
                @click="toggle" 
                @keyup.enter="toggle"
                :aria-labelledby="labelByKey()"
                :aria-roledescription="labels.menuAriaRoleDescription">{{selectedName}}
            </div>
                
            <div class="dropdown__list" v-if="open">
                <ul class="dropdown__items" >
                    
                    <!-- Single select value -->
                    <li key="all" v-if="isSingleSelect">
                        <div 
                            class="dropdown__link"
                            tabindex="0"  
                            @click="toggleItem(null)" 
                            @keyup.enter="toggleItem(null)"
                            @mouseover="tabAriaMouseEvent('all', false)"
                            @mouseleave="tabAriaMouseEvent('all', true)"
                            :class="{'dropdown__link--selected': !anySelected()}"
                            :aria-label="itemAriaGetLabel(null)"
                            :aria-roledescription="labels.menuItemAriaRoleDescription">
                            {{label}}
                        </div>
                    </li>       
                    
                    <li v-for="(item, i) in config" :key="i">
                            <div 
                                class="dropdown__link"
                                tabindex="0"  
                                @click="toggleItem(item)"
                                @keyup.enter="toggleItem(item)"
                                @mouseover.capture="tabAriaMouseEvent(item, false)"
                                @mouseleave.capture="tabAriaMouseEvent(item, true)"
                                :aria-label="itemAriaGetLabel(item)"
                                :aria-roledescription="labels.menuItemAriaRoleDescription"
                                :class="{'dropdown__link--selected': item.selected}">
                            {{item.name}}
                            </div>
                        </li>
                </ul>
                <div v-if="!isSingleSelect" class="dropdown__cta">
                    <button @click="submit()" @keyup.enter="submit()" class="button" :disabled="!buttonEnabled">{{buttonLabel}}</button>
                </div>
            </div>
        </FocusLock>
    </div>
</template>

<script>
export default {
    name: "dropdown",
    props: ["config", "label", "type", "buttonLabel", "isSingleSelect"],
    data() {
        return {
            open: false,
            allSelected: true,
            otherParams: null,
            buttonEnabled: true,
            selectedName: this.label,
            lastSelectItem: null,
            lastHoverItem: null
        };
    },
    mounted() {
        this.$store.dispatch('getLabels', { label: 'dropdown' });
        this.$parent.$on("closeOtherDropdowns", data => {
            if (data.keep !== this.type) this.closeDropdown();
        });
        this.setSelectedName();
    },
    computed:{
        labels() {
            return this.$store.state.labels["dropdown"] || {};
        }
    },
    methods: {
        toggleItem(item) {
            if(this.isSingleSelect)
            {
                this.selectSingleItem(item)
                setTimeout(()=> this.closeDropdown(), 100)
            } else{
                this.lastSelectItem = item;
                item.selected = !item.selected;
            }
            this.$emit("update", { type: this.type, data: this.config, selectedItem: item });
        },
        tabAriaMouseEvent(item, isLeaving) {
            this.lastHoverItem = isLeaving ? null : item;
        },
        itemAriaGetLabel(item){
            
            //single select - Virker!
            if(this.isSingleSelect)
            {
                // all value
                if(item === null)
                {
                    var anySelected = this.anySelected();
                    return !anySelected || (this.lastHoverItem === 'all' && anySelected) 
                    ? this.labels.menuItemAriaLabelSelected
                    : this.labels.menuItemAriaLabelNotSelected;
                }

                // rest
                return (item.selected) || (this.lastHoverItem === item && !item.selected)  
                ? this.labels.menuItemAriaLabelSelected
                : this.labels.menuItemAriaLabelNotSelected
            }

            // Multi select - keyboard + last selected hover item   
            if(this.lastHoverItem === null || (this.lastHoverItem === item && this.lastSelectItem === item))
            {
                return item.selected 
                ? this.labels.menuItemAriaLabelSelected
                : this.labels.menuItemAriaLabelNotSelected;
            }

            var result = (item.selected && this.lastHoverItem !== item) || (this.lastHoverItem === item && !item.selected) 
                        ? this.labels.menuItemAriaLabelSelected
                        : this.labels.menuItemAriaLabelNotSelected;
                    return result;
        },
        toggle() {
            if (this.open) {
                this.closeDropdown();
            } else {
                this.openDropdown();
            }
        },
        anySelected(){
            return this.config.some(x => x.selected);
        },
        setSelectedName(){
            if(this.anySelected())
            {
                this.selectedName = this.config.find(x => x.selected).name;
            }
        },
        selectSingleItem(item)
        {
            if(item !== null)
            {
                this.selectedName = item.name;
                item.selected = true;
                this.lastSelectItem = item;
            } else{
                this.selectedName = this.label;
                this.lastSelectItem = 'all';
            }

            this.config.forEach(element => {
                if(element !== item)
                {
                    element.selected = false;
                }
            });
        },
        closeDropdown(e) {
            var et = typeof e !== "undefined" ? e.target : false;

            if (!et || !et.closest(".dropdown")) {
                this.open = false;
                document.removeEventListener("click", this.closeDropdown);
            }
        },
        openDropdown() {
            this.open = true;
            this.$parent.$emit("closeOtherDropdowns", { keep: this.type });
            document.addEventListener("click", this.closeDropdown);
        },
        submit() {
            this.buttonEnabled = false;
            this.$emit("submit");
        },
        labelByKey()
        {
            return this.label.replace(/[^a-zA-Z]/g, '');
        }
    },
};
</script>



// WEBPACK FOOTER //
// src/components/Dropdown.vue